import { T } from 'gt-react';
import type { AgentPageResponse } from '@erp/rpc';
import { Spinner } from '@/components/ui/spinner';
import { useGetAgentDefinition } from 'src/api/rpc/hooks/agent-definitions/useAgentDefinitions';
import { AgentPageBody } from './AgentPageBody';

/** Loads the agent behind the page, then hands off to the body. */
export function AgentPageWithDefinition({ page }: { page: AgentPageResponse }) {
  const {
    data: definition,
    isLoading,
    isError,
  } = useGetAgentDefinition(page.agentDefinitionId);

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner />
      </div>
    );
  }
  if (isError || !definition) {
    return (
      <div className="flex h-full items-center justify-center text-sm text-muted-foreground">
        <T context="empty state when the agent behind an agent page cannot be loaded">
          The agent behind this page could not be loaded.
        </T>
      </div>
    );
  }
  return <AgentPageBody page={page} definition={definition} />;
}
